import { render, staticRenderFns } from "./CoordinatingCommitteeEditor.vue?vue&type=template&id=472ca7b0&"
import script from "./CoordinatingCommitteeEditor.vue?vue&type=script&lang=js&"
export * from "./CoordinatingCommitteeEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports